var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6797 0.723633L0.679688 4.4274V17.0151L10.6797 20.7189L20.6797 17.0151V4.4274L10.6797 0.723633ZM10.6797 7.55225L8.15375 6.61673L15.123 4.03555L17.649 4.97107L10.6797 7.55225ZM12.8736 3.20242L5.9043 5.7836L3.71039 4.97107L10.6797 2.38989L12.8736 3.20242ZM2.24219 6.09351L5.21094 7.19305V11.0508L6.77328 11.6294C6.77328 11.6288 6.77344 11.6282 6.77344 11.6276V7.77182L9.89844 8.9292V18.7632L2.24219 15.9276V6.09351ZM11.4609 18.7632V8.9292L19.1172 6.09351V15.9276L11.4609 18.7632Z",
    fill: "#06623B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.dec77b9b9af29d891118fa5af4a1aad2.svg";
export { ForwardRef as ReactComponent };